<template>
    <LayoutSub className="membership">
        <SubpageTitleContainer title="이지멤버십(EasyMembership)"
            subText="고객에게 차별화된 혜택을 제공할 수 있는 통합 멤버십 서비스입니다.<br/>맞춤형 멤버십 설계로 지속적인 서비스 사용을 유도하고 충성도 강화를 통한 매출 확대를 경험할 수 있습니다.">
        </SubpageTitleContainer>

        <SubSection class="pt-0">
            <RedTitleRow title="도입 배경">
                <li>
                    <span class="list_num">01</span>
                    비대면 서비스 확대에 따른 자체 오더 서비스 운영 니즈 증가
                </li>
                <li>
                    <span class="list_num">02</span>
                    회원 데이터 분석을 통한 타겟 마케팅 필요성 증대
                </li>
                <li>
                    <span class="list_num">03</span>
                    충성고객 록인을 통한 수익 안정성 확보
                </li>
            </RedTitleRow>
        </SubSection>

        <SubSection type="wide">
            <SubTitle3 listStyle="dot">특징</SubTitle3>
            <div class="table-2grid">
                <TableRow_2grid src="ic-membershop1.png" title="복합 서비스 구축"
                    content="POS, PG, 부가 서비스 등 KICC에서 제공하고 있는 서비스를 결합하여 일원화된 통합 멤버십을 제공합니다." />
                <TableRow_2grid src="ic-membershop2.png" title="기본 정보 연동 자동화"
                    content="매장/상품정보 등 자동 연동되는 이지포스 설정값으로 추가 셋팅 없이 <br />시스템 사용이 가능하며 매장에서 사용 중인 이지포스로 APP 주문 접수가 가능합니다." />
                <TableRow_2grid src="ic-membershop3.png" title="디테일한 프로모션 설정"
                    content="다양한 고객 대상의 이벤트를 진행하기 위한 세부 조건 설정이 가능하며 성과 분석을 통해 효과적인 마케팅이 가능합니다." />
                <TableRow_2grid src="ic-membershop4.png" title="맞춤형 데이터 제공"
                    content="APP 및 POS 주문 데이터 연계 분석을 위해 원하는 조건에 맞는 데이터를 제공합니다." />
            </div>
        </SubSection>

        <SubSection class="pb-0">
            <SubTitle3 listStyle="dot">시스템 구성</SubTitle3>
            <div class="system_composition_container">
                <div class="row">
                    <div class="line_box">
                        <div class="line_box_header">
                            <div class="header-title-area">주요 기능</div>
                        </div>
                        <div class="line-box-body">
                            <div class="content">
                                <div class="inner_line_box">
                                    <p class="inner_line_box_title">회원관리</p>
                                    <ul class="inner_line_box_list">
                                        <li>간편 로그인</li>
                                        <li>상태별/등급별 관리</li>
                                    </ul>
                                </div>
                                <div class="inner_line_box">
                                    <p class="inner_line_box_title">주문</p>
                                    <ul class="inner_line_box_list">
                                        <li>매장/픽업 주문</li>
                                        <li>배달 주문</li>
                                    </ul>
                                </div>
                                <div class="inner_line_box">
                                    <p class="inner_line_box_title">리워드</p>
                                    <ul class="inner_line_box_list">
                                        <li>스탬프</li>
                                        <li>포인트</li>
                                        <li>쿠폰</li>
                                    </ul>
                                </div>
                                <div class="inner_line_box">
                                    <p class="inner_line_box_title">이벤트</p>
                                    <ul class="inner_line_box_list">
                                        <li>프로모션</li>
                                        <li>프리퀀시 이벤트</li>
                                    </ul>
                                </div>
                                <div class="inner_line_box">
                                    <p class="inner_line_box_title">통계</p>
                                    <ul class="inner_line_box_list">
                                        <li>대시보드</li>
                                        <li>맞춤형 데이터</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SubSection>
    </LayoutSub>
</template>
<script>
import RedTitleRow from '@/components/RedTitleRow.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import SubSection from '@/components/SubSection.vue';
import SubTitle3 from '@/components/SubTitle3.vue';
import TableRow_2grid from '@/components/TableRow_2grid.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubpageTitleContainer,
        SubSection,
        SubTitle3,
        RedTitleRow,
        TableRow_2grid,
    },
};
</script>